<template>
  <div class="main">
    <p class="title">POSTAGENS ANÔNIMAS</p>
    <b-row align-h="end">
      <b-col cols="10" sm="6" md="6" lg="4" class="buttonPosition">
        <b-button
          class="buttons"
          v-if="this.aproved"
          @click="abrirModal(false)"
          v-on:click="PatchFormById()"
          >Remover Aprovação</b-button
        >
        <b-button
          class="buttons"
          v-else
          @click="abrirModal(true)"
          v-on:click="PatchFormById()"
          >Aprovar</b-button
        >
        <b-button class="buttons1" v-b-modal.idModalPostagens> Excluir</b-button>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col cols="9" sm="9" md="12" lg="12">
        <p class="styleTitle">{{ this.TITLE }}</p>
      </b-col>
    </b-row>
    <PopupConfirmacao
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="A postagem será excluida permantemente. Deseja continuar?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="deletar"
      id_modal="idModalPostagens"
    />
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="11">
        <Tabela />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Tabela from '@/components/dashboard/Postagens.vue';
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
import {
  GetAnonymousPostsId,
  deleteAnonymousContact,
  PatchAnonymous,
} from '@/services/api/AnonymousContact.js';

import backUrl from '@/utils/backUrl.js';
import { seo } from '@/utils/seo.js';

export default {
  name: 'Postagens',
  components: {
    Tabela,
    PopupConfirmacao,
  },
  metaInfo() {
    return seo(
      'Editar ' + this.TITLE,
      'Editar Postagem Anônima - Site do Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
      ' - Dashboard Projeto Niara',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
      destinationId: this.$route.params.id,
      MESSAGE: '',
      TITLE: '',
      id: '',
      aproved: undefined,
    };
  },
  methods: {
    abrirModal(aproved) {
      this.aproved = aproved;
    },
    async PatchFormById() {
      await PatchAnonymous(this.destinationId, { aproved: this.aproved })
        .then(() => {
          this.$router.push({ name: 'Postagens' });
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },

    deletar() {
      deleteAnonymousContact(this.destinationId)
        .then(() => {
          this.$router.push({ name: 'Postagens' });
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },
  },
  mounted() {
    GetAnonymousPostsId(this.destinationId)
      .then((res) => {
        this.TITLE = res.data.title;
        this.aproved = res.data.aproved;
        this.id = res.data._id;
      })
      .catch(() => {
        this.$bvToast.toast(
          'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
          {
            title: 'Erro interno no servidor',
            autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
            variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
          },
        );
      });
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 3rem;
}

.buttons {
  background-color: #343842;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
}
.buttons1 {
  background-color: #eb5353;
  margin-top: 0.5rem;
}
p {
  font-size: 2rem;
  font-weight: bold;
}
@media (min-width: 769px) and (max-width: 1024px) {
  .main {
    margin-left: 11rem;
  }
  p {
    font-size: 1.8rem;
    font-weight: bold;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .main {
    margin-left: 8.5rem;
    margin-right: 0.5rem;
  }
  p {
    font-size: 1.8rem;
    font-weight: bold;
  }
  .buttonPosition {
    margin-right: 0rem;
    margin-bottom: 1rem;
  }
  .buttons1 {
    margin-top: 0.5rem;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .main {
    margin-left: 6.3rem;
  }
  p {
    font-size: 1.6rem;
    font-weight: bold;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .main {
    margin-left: 5.4rem;
  }
  p {
    font-size: 1.4rem;
    font-weight: bold;
  }
}
@media (max-width: 320px) {
  .main {
    margin-left: 5rem;
  }
  p {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
@media (max-width: 280px) {
  .main {
    margin-left: 5rem;
  }
  .styleTitle {
    font-size: 1rem;
    font-weight: bold;
  }
  p.title {
    font-size: 1rem;
    font-weight: bold;
  }
  .buttonPosition {
    margin-right: 1.5rem;
    margin-bottom: 1rem;
  }
}
</style>
